import { useTranslation } from 'react-i18next';
import styles from './LoadingState.module.css';

export interface LoadingStateProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  fullHeight?: boolean;
  /** Fill the flex parent — use inside flex containers that need the spinner to center in available space. */
  fill?: boolean;
}

export function LoadingState({ label, size = 'md', fullHeight = false, fill = false }: LoadingStateProps) {
  const { t } = useTranslation();
  const text = label ?? t('common.loading');

  return (
    <div
      className={[styles.root, styles[size], fullHeight ? styles.fullHeight : '', fill ? styles.fill : ''].filter(Boolean).join(' ')}
      role="status"
      aria-label={text}
    >
      <div className={styles.spinner} aria-hidden="true">
        <svg className={styles.svg} viewBox="0 0 24 24" fill="none">
          <circle className={styles.track} cx="12" cy="12" r="10" strokeWidth="2" />
          <circle className={styles.arc} cx="12" cy="12" r="10" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <span className={styles.dots}>···</span>
      </div>
      <p className={styles.label}>{text}</p>
    </div>
  );
}
